module.exports = __webpack_public_path__ + "img/payment_details_failed.0cc1901b.svg";